import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a24d008&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a24d008')) {
      api.createRecord('4a24d008', component.options)
    } else {
      api.reload('4a24d008', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a24d008&", function () {
      api.rerender('4a24d008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantMember/role/index.vue"
export default component.exports